export class Initiator {
    'id';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Initiator.attributeTypeMap;
    }
    constructor() {
    }
}
